import styles from './WaveDivider.module.css';
import classnames from 'classnames';
import waveDivider from '../../img/DarkC.svg';

function WaveDivider({ ...props }) {
  const { color, animate } = props;

  const className = classnames({
    [`${styles[color]}`]: true,
    [styles.animate]: animate
  });

  return (
    <div className={`${styles.WaveDivider} ${className}`}>
      <div></div>
      <img src={waveDivider} alt="wave divider" layout={'fill'} />
    </div>
  );
}

export default WaveDivider;
